<template>
  <el-dialog title="Produkt Instanzen erstellen"
    width="50%"
    :visible="show"
    @close="$emit('close')"
  >
    <div class="row" v-if="productId">
      <div class="col-sm-12">
        <form @submit.prevent="submit">
          <div class="form-group has-label">
            <warehouse-select
              v-model="warehouse"
              :options="warehouses"
            />
          </div>
          <table class="table">
            <thead>
              <tr>
                <th colspan="2">Variation</th>
                <th class="text-center">Anzahl</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="variation in variations" :key="variation.id">
                <td>{{ variation.name }}</td>
                <td>
                  <ul style="margin-bottom: 0;">
                    <li v-for="stringRep in variation.stringRep" :key="stringRep" v-text="stringRep"></li>
                  </ul>
                </td>
                <td>
                  <input type="number" v-model="variation.instancesToCreate"
                    class="form-control float-right"
                    style="width: 100px;" min="0"
                  >
                </td>
              </tr>
            </tbody>
          </table>
          <div class="d-flex justify-content-between">
            <button type="submit" class="btn btn-fill btn-primary" :disabled="! canSubmit">
              Erstellen
            </button>
            <button class="btn btn-fill btn-default"
              @click.prevent="$emit('close')"
            >
              Abbrechen
            </button>
          </div>
        </form>
      </div>
    </div>
  </el-dialog>
</template>

<script>
import { Dialog } from 'element-ui'
import WarehouseSelect from 'src/components/warehouse-select.vue'

export default {
  props: ['show', 'productId', 'variations'],
  components: {
    [Dialog.name]: Dialog,
    WarehouseSelect
  },
  data () {
    return {
      warehouses: [],
      warehouse: this.$store.state.filters.warehouse
    }
  },
  methods: {
    async submit () {
      await this.initCsrf()

      const variations = this.variations.reduce((sum, variation) => {
        if (!isNaN(variation.instancesToCreate) && variation.instancesToCreate > 0) {
          sum.push({
            id: variation.id,
            qty: variation.instancesToCreate
          })
        }
        return sum
      }, [])

      const url = `/products/${this.productId}/variations_instances`
      this.$http.post(url, {
        warehouse_id: this.warehouse.id,
        variations
      }).then(({ data }) => {
        this.$emit('created', data)
      })
    }
  },
  computed: {
    canSubmit () {
      return this.warehouse && this.variations.length
    }
  },
  created () {
    this.$http.get('/warehouses').then(({ data }) => { this.warehouses = data })
  }
}
</script>

<style>
</style>
